type PropertyType =
  | "comparable-active"
  | "comparable-pending"
  | "comparable-sold"
  | "other";

const colors = {
  active: "#107F10", // successColor
  sold: "#D90D02", // dangerColor
  pending: "#FFCE45", // warningColor
  other: "#131319", // primaryColor
};

const createDictionary = (options: { label: string; value: string }[]) =>
  Object.assign({}, ...options.map((x) => ({ [x.value]: x.label })));

export const propertyTypeOptions = [
  { label: "Condo", value: "condo" },
  { label: "Co-op", value: "co-op" },
  { label: "Multi Family", value: "multi-family" },
  { label: "Single Family", value: "single-family" },
  { label: "Townhouse", value: "townhouse" },
  { label: "TIC", value: "tic" },
  { label: "Land", value: "land" },
  // { label: 'Other', value: 'other' }, // Since other is a free text, no reason to be an option
];
export const propertyTypeDictionary = createDictionary(propertyTypeOptions);

export const getPropertyTypeLabel = (value?: string | null) => {
  return propertyTypeDictionary[value ?? ""] || value;
};

export const propertyStatusesMap = {
  1000: { rawStatus: "Sold", status: "sold" },
  1001: { rawStatus: "Active", status: "active" },
  1002: { rawStatus: "Active Under Contract", status: "contingent" },
  1003: { rawStatus: "Contingent", status: "contingent" },
  1004: { rawStatus: "Pending", status: "pending" },
  1005: { rawStatus: "Coming Soon", status: "soon" },
  1006: { rawStatus: "Off Market", status: null },
  1010: {
    rawStatus: "Pending - Backup Offer Requested",
    status: "pending-backup-offer-requested",
  },
} as const;

export const getPropertyMarkerColorByType = (type: string) => {
  if (type === "comparable-active") return colors.active;
  else if (type === "comparable-sold") return colors.sold;
  else if (type === "comparable-pending") return colors.pending;
  return colors.other;
};

export const parseComparablePropertyType = (
  listingStatus: string | null | undefined,
): PropertyType => {
  const normalizedStatus = getStatusByListingStatus(listingStatus as any);
  if (!normalizedStatus) return "other";
  if (normalizedStatus === "sold") return "comparable-sold";
  if (["active", "soon"].includes(normalizedStatus)) return "comparable-active";
  if (["pending", "contingent"].includes(normalizedStatus))
    return "comparable-pending";
  return "other";
};

export type PropertyStatusesKey = keyof typeof propertyStatusesMap;

export const getStatusByListingStatus = (
  listingStatus: (typeof propertyStatusesMap)[PropertyStatusesKey]["rawStatus"],
) => {
  const propertyMapValue = Object.entries(propertyStatusesMap).find(
    ([_k, v]) => v.rawStatus === listingStatus,
  )?.[1];

  return propertyMapValue?.status;
};
